import { z } from 'zod'

const fingerprintSchema = z.union([
  z.literal('MISSING'),
  z.string().regex(/^[a-f0-9]{64}$/),
])

export const hygieneRecallConfigurationSchema = z
  .object({
    enabled: z.boolean(),
    recallIntervalMonths: z.number().int().min(3).max(24),
    qualifyingAppointmentTypeIds: z.array(z.number().int().positive()).max(100),
  })
  .strict()

export const campaignSettingsResponseSchema = z
  .object({
    schemaVersion: z.literal(1),
    status: z.enum([
      'AUTHORITY_UNAVAILABLE',
      'RESOURCE_REFRESH_REQUIRED',
      'AVAILABLE',
    ]),
    platformEntitled: z.boolean(),
    configuration: z
      .object({
        configRevision: z.number().int().nonnegative(),
        configFingerprint: fingerprintSchema,
        hygieneRecall: hygieneRecallConfigurationSchema,
        appointmentTypes: z.array(
          z
            .object({
              id: z.number().int().positive(),
              name: z.string().min(1),
              minutes: z.number().int().positive(),
            })
            .strict()
        ),
        configurationState: z.enum(['READY', 'INCOMPLETE', 'REVIEW_REQUIRED']),
        missingAppointmentTypeIds: z.array(z.number().int().positive()),
        executionState: z.literal('HISTORY_COVERAGE_REQUIRED'),
      })
      .strict()
      .nullable(),
  })
  .strict()

export const campaignSettingsUpdateSchema = z
  .object({
    expectedConfigRevision: z.number().int().nonnegative(),
    expectedConfigFingerprint: fingerprintSchema,
    hygieneRecall: hygieneRecallConfigurationSchema,
  })
  .strict()

export type CampaignSettingsResponse = z.infer<
  typeof campaignSettingsResponseSchema
>
export type CampaignSettingsUpdate = z.infer<
  typeof campaignSettingsUpdateSchema
>
export type HygieneRecallConfiguration = z.infer<
  typeof hygieneRecallConfigurationSchema
>
